import * as React from 'react';
import { TextField, FormControl } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import { IUnitecConfig } from '../../_types/location';

interface Props {
    classes: any;
    /** the item to display */
    item: IUnitecConfig;
    onChange: (config: any) => void;
};

// LEARN
const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
        }
//     home: { color: "primary" },
//     away: { color: theme.palette.grey[900] }
}));

const UnitecConfig: React.FC<Props> = (prop: Props) => {

    const classes = useStyles();

    return (
    <Grid container direction="row" alignItems="center">
        <Grid item>
            <FormControl className={classes.formControl}>
                <TextField label="Device Id" value={prop.item.DeviceId} onChange={(e) => {let i = prop.item; i.DeviceId = e.target.value; prop.onChange(i)}}></TextField>
            </FormControl>
        </Grid>
        <Grid item>
        <FormControl className={classes.formControl}>
                <TextField label="Site Id" value={prop.item.SiteId} onChange={(e) => {let i = prop.item; i.SiteId = e.target.value; prop.onChange(i)}}></TextField>
            </FormControl>
        </Grid>
        <Grid item>
        <FormControl className={classes.formControl}>
                <TextField label="User Name" value={prop.item.Username} onChange={(e) => {let i = prop.item; i.Username = e.target.value; prop.onChange(i)}}></TextField>
            </FormControl>
        </Grid>
        <Grid item>
        <FormControl className={classes.formControl}>
                <TextField label="Password" value={prop.item.Password} onChange={(e) => {let i = prop.item; i.Password = e.target.value; prop.onChange(i)}}></TextField>
            </FormControl>
        </Grid>
    </Grid>
    );
}

export default UnitecConfig;